module.exports = __webpack_public_path__ + "static/media/device.95b3b9e7.svg";